import {saveAccessToken} from "@/helper";
import {errorMessage} from "@/utils/message";
import axios from "axios";


// let token = localStorage.getItem(ACCESS_TOKEN)
axios.defaults.headers.post["Content-Type"] = "application/json";
// axios.defaults.headers.common["Authorization"] = token;

//******** fix null Authorization key ******************
// let accessTokenTimer = setInterval(() => {
//     killTimer()
// }, 200);
//
// const killTimer = () => {
//     token = localStorage.getItem(ACCESS_TOKEN);
//     if (token !== null) {
//         axios.defaults.headers.common["Authorization"] = token;
//          clearInterval(accessTokenTimer)
//     }
// }
// ********** end of fix *************


axios.interceptors.response.use(null, error => {
    const executedErrors = error.response && error.response.status >= 400 && error.response.status < 500;
    if (executedErrors) {
        // console.log(error, "HttpService")

        if (error.response.status === 401) {
            let lastAuthenticateError = Number(localStorage.getItem('last_authenticate')) || 0;
            let now = Date.now();

            // مثلا اجازه بده فقط هر 1 دقیقه یک بار پیام نمایش داده بشه
            let cooldown = 60 * 1000; // 1 دقیقه

            if (now > lastAuthenticateError + cooldown) {
                localStorage.setItem('last_authenticate', String(now));
                saveAccessToken(null);
                if (document.location.pathname === '/') {
                    // errorMessage('کد یکبار مصرف وارد شده اشتباه است')
                }
                if (document.location.pathname !== '/') {
                    errorMessage('لطفا مجددا وارد شوید')
                    setTimeout(() => {
                        document.location.reload()
                    }, 3 * 1000)
                }
            }
        }

        if (error.response.status === 403) {
            let lastForbiddenTime = Number(localStorage.getItem('last_forbidden')) || 0;
            let now = Date.now();

            // مثلا اجازه بده فقط هر 1 دقیقه یک بار پیام نمایش داده بشه
            let cooldown = 60 * 1000; // 1 دقیقه

            if (now > lastForbiddenTime + cooldown) {
                errorMessage('دسترسی شما محدود شد. این یک کسب‌وکار خصوصی است، لطفاً از مالک کسب‌وکار بخواهید تا دسترسی مجاز برای شما ایجاد کند.');

                localStorage.setItem('last_forbidden', String(now));

                if (document.location.pathname !== '/') {
                    saveAccessToken(null).then(() => {
                        setTimeout(() => {
                            document.location.reload();
                        }, 10 * 1000);
                    });
                }
            }
        }

        //
        // if (error.response.status === 400 && document.location.pathname !== '/account/register') {
        //     // console.log('document.location.pathname',document.location.pathname)
        //     let msg = '';
        //     let res = error?.response?.data?.message
        //     // console.log('message error', res)
        //     try {
        //         msg = JSON.parse(res)?.errors.join("\r\n")
        //     } catch (e) {
        //         // errorMessage(res);
        //     }
        //
        //     if (!res) {
        //         msg = error?.response?.data?.msg;
        //     }
        //     // if (!empty(msg))
        //     //     errorMessage(msg);
        //
        // }
    }

    return Promise.reject(error)
});

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    axios: axios
}